module.exports = __webpack_public_path__ + "media/slow2-h265.6d9d6cde.mp4";